module.exports = __webpack_public_path__ + "static/media/bytt-no-17.d1f894c6.mp3";